'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function request(url) {
  let result;
  var xhr = new XMLHttpRequest();
  xhr.addEventListener("readystatechange", function () {
    if (this.readyState === 4) {
      result = this.responseText;
    }
  });
  xhr.open("GET", url, false);
  xhr.send();
  return result
}

const ossHost = "https://sky-config.oss-cn-hangzhou.aliyuncs.com/webconfig";
const ossUrls = {
  development: `${ossHost}/host-config-dev.json`,
  production: `${ossHost}/host-config-prod.json`,
  testing: `${ossHost}/host-config-test.json`,
  preProduction: `${ossHost}/host-config-pre.json`
};

function validateInit(systemName, env) {
  if (!systemName) throw new Error(`必须传入系统名称参数.`)
  if (!env) throw new Error(`必须传入环境变量参数.`)
  if (Object.keys(ossUrls).indexOf(env) == -1) {
    throw new Error(`没有${env}环境的域名配置文件.`)
  }
}
function hasInit(config) {
  if (!config.baseSystemName || !config.data) throw new Error(`请先调用init方法.`)
}
function isFullUrl(url) {
  return url.startsWith('//') || url.startsWith('http') || url.startsWith('https')
}

let _config = {};
function init(systemName, env) {
  validateInit(systemName, env);
  _config.baseSystemName = systemName;
  let url = ossUrls[env];
  let timestamp = new Date().getTime();
  let response = request(url + "?time=" + timestamp);
  _config.data = JSON.parse(response);
}

function getRequestUse(config) {
  hasInit(_config);
  if (isFullUrl(config.url)) return config
  const reg = /\#[^\)]*\#/;
  let matchResult = config.url.match(reg);
  let systemName = matchResult ? matchResult[0].replaceAll('#', '') : _config.baseSystemName;
  let domain = getDomain(systemName).api;
  config.url = matchResult ? config.url.replace(reg, domain) : domain + config.url;
  return config
}
function getDomain(systemName) {
  hasInit(_config);
  if (!systemName) return _config.data
  let systemData = _config.data[systemName];
  if (!systemData) throw new Error(`没有配置${systemName}系统的域名.`)
  return systemData
}

exports.getDomain = getDomain;
exports.getRequestUse = getRequestUse;
exports.init = init;



//////////////////
// WEBPACK FOOTER
// ./node_modules/sky-domain/dist/sky-domain.js
// module id = qW2I
// module chunks = 5